import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';
import { OrganizationTypes } from '@sravni/ugc/lib/organizations/types';

import { CUSTOMER_TYPE_TO_ROUTE, RATING_TYPES } from '../../constants/filters';
import type { TFindParams } from '../services/metadata';

type TParams = {
  filters: TFilters;
};

export const prepareSeoParams = ({ filters }: TParams): TFindParams => {
  const { organizationType, service, customerType, location, ratingType } = filters;

  const helper = getOrganizationHelpers(organizationType);
  let url = organizationType === OrganizationTypes.Mfo ? `/${helper.listTypeUrl}/mfo` : `/${helper.listTypeUrl}`;
  if (ratingType === RATING_TYPES.Organizations) {
    url = `${url}/rating`;
  } else if (ratingType === RATING_TYPES.Products) {
    url = `${url}/rating-productov`;
  }

  const customerTypeString = CUSTOMER_TYPE_TO_ROUTE[customerType] ?? 'obshee';
  url = `${url}/${customerTypeString}`;

  if (service) {
    url = `${url}/${service.alias}`;
  }

  if (location) {
    url = `${url}/${location.alias}`;
  }

  return {
    url,
    reviewTag: service
      ? {
          name: service.label,
          alias: service.alias,
        }
      : null,
    location,
  };
};
